import { alpha, Theme } from "@mui/material/styles";

export const useStyle = (theme: Theme) => ({
  paper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: 2,
    display: "flex",
    flexDirection: "column",
    height: "580px",
    gap: 2,
    width: "90vw",
    maxWidth: "800px",
    minWidth: "400px",
    [theme.breakpoints.down("md")]: {
      width: "400px",
    },
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto",
  },
  svgStyle: {
    width: "120px",
    height: "120px",
    fill: theme.palette.text.disabled,
  },
  container: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  modalContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  headerContainer: { display: "flex", justifyContent: "space-between" },
  TextField: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mt: 2,
    width: "100%",
  },
  selectContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  cancelButton: {
    backgroundColor: theme.palette.background.textField,
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: alpha(theme.palette.background.textField, 0.5),
    },
  },
});
